module.exports = {
  title: 'Торнадо',
  validators: {
    required: 'Это поле обязательно к заполнению',
    passwordMustMatch: 'Пароль должен совпадать',
    invalidEmail: 'Неверный адрес электронной почты',
    maxLength: 'Поле не должно превышать {length} символов',
    minValue: 'Допустимое минимальное значение {value}',
    minArrayValue: 'Выберите как минимум {value} элемент | {value} элемента',
    minValueExcluded: 'Значение должно быть больше {value}',
    maxValue: 'Допустимое максимальное значение {value}',
    maxValueExcluded: 'Значение должно быть меньше {value}',
    selectAtLeastOne: 'Выберите хотя бы один вариант',
    firstName: 'Требуется имя',
    lastName: 'Требуется фамилия',
    notAvailableAtThisDate: 'Не доступен(-на) в указанную дату ({date})',
    priceIsNotSetAtThisDate: 'Цена не установлена для указанной даты ({date})',
    requiredPriceDefinition: 'Цена не определена в системе',
    cashBoxAmountValidator: `Значения в колонке 'Фактически' должны быть заполнены и не быть отрицательными`,
  },
  errorMessages: {
    validators: {
      keys: {
        orderItems: `"Список заказов"`,
        privileges: `"Список привилегий"`,
        overprice: `"Наценочная цена"`,
        price: `"Цена"`,
        wholesalePrice: `"Оптовая цена"`,
        quantity: `"Количество"`,
        discount: `"Скидка"`,
        paginationSkip: `"Пропуск пагинации"`,
        paginationTake: `"Количество пагинации"`,
        reviewStars: `"Отзыв"`
      },
      ArrayMinSize: 'Минимальный размер {key} должен быть больше или равен {value}',
      MinFieldEq: '{key} должен быть больше или равен {value}',
      MinExclude: '{key} должен быть больше {value}',
      Min: '{key} должен быть больше или равен {value}',
      Max: '{key} должен быть меньше или равен {value}',
    },
    notFound: {
      keys: {
        user: 'Пользователь',
        home: '"Главная" страница',
        client: 'Клиент',
        coupon: 'Купон',
        branch: 'Филиал',
        order: 'Заказ',
        about: 'Одна из страниц "О нас"',
        product: 'Товар',
        contact: 'Контакт',
        faq: 'Одна из страниц "FAQ"',
        request: 'Запрос',
        funFact: 'Одна из страниц "Интересный факт"',
        project: 'Проект',
        whyWe: 'Одна из страниц "Почему мы"',
        service: 'Одна из страниц "Услуга"',
        skillMain: 'Страница "Навык"',
        staff: 'Персонал',
        skill: 'Навык',
        socialLink: 'Социальная сеть',
        userGroup: 'Группа пользователей',
        testimonial: 'Отзыв',
        productBrand: 'Бренд товара',
        productReview: 'Отзыв о товаре',
        productCategory: 'Категория товара',
        mainCurrency: 'Основная валюта',
        currency: 'Валюта',
        feature: 'Условие',
        productReviewReply: 'Ответ на отзыв о товаре',
        productSubcategory: 'Подкатегория товара',
        blog: 'Блог',
        pricePolicy: 'Политика цен',
        productPrice: 'Цена товара',
        orderPayment: 'Оплата заказа',
        orderItem: 'Товар заказа',
        publicOffer: 'Публичная оферта',
        privacyPolicy: 'Политика конфиденциальности'
      },
      message: '{key} не найден'
    },
    'Failed to fetch': 'У вас проблемы с подключением, проверьте интернет и попробуйте снова',
    FILE_FORMAT_IS_NOT_ALLOWED: 'Этот тип файла не поддерживается',
    FILE_SIZE_EXCEEDED_MAX_LIMIT: 'Файл слишком большой для загрузки',
    CLIENT_ALREADY_EXISTS: 'Пользователь с таким email уже существует в системе',
    INVALID_CREDENTIALS: 'Введенный email или пароль неверны',
    INVALID_REFRESH_TOKEN: 'Сессия истекла или недействительна. Пожалуйста, войдите снова',
    RESET_TOKEN_FORBIDDEN: 'Сброс пароля недоступен для этого аккаунта',
    BRANCH_ID_REQUIRED: 'Пожалуйста, выберите филиал для продолжения',
    ORDER_CAN_NOT_BE_COMPLETED: 'Этот заказ не может быть выполнен в данный момент',
    ORDER_CAN_NOT_BE_CANCELED: 'Этот заказ не может быть отменен',
    ORDER_CAN_NOT_BE_RETURNED: 'Этот заказ не может быть возвращен',
    INSUFFICIENT_ROLE: 'У вас недостаточно прав для выполнения этого действия',
    USER_GROUP_ALREADY_EXISTS: 'Эта группа пользователей уже существует',
    USER_GROUP_CAN_NOT_BE_DELETED_BECAUSE_OF_ACTIVE_USERS: 'Вы не можете удалить эту группу, так как в ней есть активные пользователи',
    CAN_NOT_REMOVE_ACTUAL_USER: 'Вы не можете удалить текущего активного пользователя',
    INVALID_OWNERSHIP: 'У вас нет прав владения для выполнения этого действия',
    INVALID_RESET_TOKEN: 'Ссылка для сброса пароля недействительна или истекла',
    PRODUCT_CATEGORY_OR_SUBCATEGORY_REQUIRED: 'Необходимо указать категорию или подкатегорию товара',
    REQUIRED_LATIN_SYMBOLS: 'Нужна хотя бы 1 английская буква для "Названия" на английском',
    CANNOT_REMOVE_LAST_ORDER_ITEM: 'Нельзя удалить, нужен хотя бы 1 товар в заказе',
    ORDER_HAS_ALREADY_LINKED_TO_CLIENT: 'Заказ уже привязан к клиенту',
    blog_duplicate_title_en_idx: 'Название блога на английском языке должен быть уникальным. Пожалуйста, выберите другой название.',
    blog_duplicate_title_ru_idx: 'Название блога на русском языке должен быть уникальным. Пожалуйста, выберите другой название.',
    blog_duplicate_title_kg_idx: 'Название блога на киргизском языке должен быть уникальным. Пожалуйста, выберите другой название.',
    blog_duplicate_alt_idx: 'Название блога (slugify) должен быть уникальным. Пожалуйста, измените английский название.',
    blog_time_to_read_gte_0: 'Время на чтение блога не может быть отрицательным.',
    blog_word_count_gte_0: 'Количество слов в блоге не может быть меньше нуля.',
    client_register_confirm_code_email_unique_idx: 'Ошибка регистрации, этот адрес электронной почты уже зарегистрирован.',
    client_reset_token_email_unique_idx: 'Ошибка сброса пароля, уже существует активный токен сброса для этого email.',
    client_email_duplicate_idx: 'Этот адрес электронной почты уже используется. Пожалуйста, используйте другой адрес.',
    client_cart_product_duplicate_idx: 'Невозможно добавить один и тот же товар в корзину больше одного раза.',
    client_cart_quantity_gt_0: 'Количество товаров в корзине должно быть больше нуля.',
    client_wishlist_product_duplicate_idx: 'Невозможно добавить один и тот же товар в список желаемого больше одного раза.',
    branch_duplicate_title_en_idx: 'Название филиала на английском языке должен быть уникальным. Пожалуйста, выберите другой название.',
    branch_duplicate_title_ru_idx: 'Название филиала на русском языке должен быть уникальным. Пожалуйста, выберите другой название.',
    branch_duplicate_title_kg_idx: 'Название филиала на киргизском языке должен быть уникальным. Пожалуйста, выберите другой название.',
    order_item_quantity_gt_0: 'Количество товаров в заказе должно быть больше нуля.',
    order_item_price_gte_0: 'Цена товара в заказе должна быть больше или равна нулю.',
    order_total_price_gte_0: 'Общая сумма заказа должна быть больше или равна нулю.',
    order_price_without_coupon_limit: 'Цена без скидки должна быть больше или равна общей сумме заказа.',
    product_brand_duplicate_title_en_idx: 'Название бренда товара на английском языке должен быть уникальным. Пожалуйста, выберите другой название.',
    product_brand_duplicate_title_ru_idx: 'Название бренда товара на русском языке должен быть уникальным. Пожалуйста, выберите другой название.',
    product_brand_duplicate_title_kg_idx: 'Название бренда товара на киргизском языке должен быть уникальным. Пожалуйста, выберите другой название.',
    product_brand_duplicate_alt_idx: 'Slugify название бренда товара должно быть уникальным. Пожалуйста, измените английское название.',
    product_category_duplicate_title_en_idx: 'Название категории товара на английском языке должен быть уникальным. Пожалуйста, выберите другой название.',
    product_category_duplicate_title_ru_idx: 'Название категории товара на русском языке должен быть уникальным. Пожалуйста, выберите другой название.',
    product_category_duplicate_title_kg_idx: 'Название категории товара на киргизском языке должен быть уникальным. Пожалуйста, выберите другой название.',
    product_category_duplicate_alt_idx: 'Slugify название категории товара должно быть уникальным. Пожалуйста, измените английское название.',
    product_price_price_gte_0: 'Цена товара должна быть больше или равна нулю.',
    product_price_overprice_limit: 'Переплата должна быть либо null, либо больше или равна обычной цене.',
    product_price_product_currency_uk: 'Цена товара должна быть уникальной для каждой валюты.',
    product_subcategory_duplicate_title_en_idx: 'Название подкатегории товара на английском языке должен быть уникальным. Пожалуйста, выберите другой название.',
    product_subcategory_duplicate_title_ru_idx: 'Название подкатегории товара на русском языке должен быть уникальным. Пожалуйста, выберите другой название.',
    product_subcategory_duplicate_title_kg_idx: 'Название подкатегории товара на киргизском языке должен быть уникальным. Пожалуйста, выберите другой название.',
    product_subcategory_duplicate_alt_idx: 'Slugify название подкатегории товара должно быть уникальным. Пожалуйста, измените английское название.',
    product_duplicate_title_en_idx: 'Название товара на английском языке должен быть уникальным. Пожалуйста, выберите другой название.',
    product_duplicate_title_ru_idx: 'Название товара на русском языке должен быть уникальным. Пожалуйста, выберите другой название.',
    product_duplicate_title_kg_idx: 'Название товара на киргизском языке должен быть уникальным. Пожалуйста, выберите другой название.',
    product_duplicate_alt_idx: 'Slugify название товара должно быть уникальным. Пожалуйста, измените английское название.',
    product_quantity_gt_0: 'Количество товара должно быть null или больше нуля.',
    product_discount_limit: 'Скидка на товар должна быть либо null, либо значение от 0 до 1.',
    product_subcategory_or_category: 'Товар должен принадлежать либо категории, либо подкатегории.',
    product_review_value_limit: 'Значение отзыва о товаре должно быть больше 0 и меньше или равно 5.',
    product_review_product_client_uk: 'Вы не можете оставить отзыв, так как уже оставили его.',
    user_group_privilege_alt_duplicate_idx: 'Привилегия с альтернативным текстом должна быть уникальной.',
    user_email_duplicate_idx: 'Этот адрес электронной почты уже зарегистрирован в системе. Пожалуйста, используйте другой адрес.',
    order_discount_limit: 'Скидка заказа должна быть между 0 и 100%'
  },
  toast: {
    imageUpdated: 'Изображение обновлено',
    imageDataUpdated: 'Данные изображения обновлены',
    dataSaved: 'Данные сохранены'
  },
  toolbar: {
    tabs: {
      admin: 'Администрация',
      shop: 'Магазин'
    },
  },
  languages: {
    middle: {
      en: 'англ',
      ru: 'рус',
      kg: 'кырг'
    },
    long: {
      en: 'Английский',
      ru: 'Русский',
      kg: 'Кыргызский'
    }
  },
  currency: {
    EUR: 'Евро',
    CNY: 'Китайский юань',
    KZT: 'Казахский тенге',
    KGS: 'Кыргызский сом',
    KRW: 'Южнокорейская вона',
    RUB: 'Российский рубль',
    TRY: 'Турецкая лира',
    GBP: 'Британский фунт',
    UZS: 'Узбекский сум',
    USD: 'Доллар США'
  },
  date: {
    months: {
      short: ['янв', 'фев', 'мар', 'апр', 'май', 'июнь', 'июль', 'авг', 'сен', 'окт', 'ноя', 'дек'],
      full: ['январь', 'февраль', 'март', 'апрель', 'май', 'июнь', 'июль', 'август', 'сентябрь', 'октябрь', 'ноябрь', 'декабрь'],
    },
    days: {
      short: ['вс', 'пн', 'вт', 'ср', 'чт', 'пт', 'сб'],
    },
    times: {
      short: {
        days: 'д.',
        hours: 'ч.',
        minutes: 'м.',
        seconds: 'с.'
      }
    },
  },
  common: {
    loading: 'Загрузка',
    noData: 'Нет данных',
    confirmDialog: 'Вы уверены, что хотите продолжить эту операцию?',
    deletionConfirmation: 'Вы уверены, что хотите удалить?',
    softDeletionConfirmation: 'Вы уверены, что хотите показать/скрыть?',
    oops: 'Упс',
    accessDenied: 'Доступ запрещен',
    pageNotFound: 'Страница не найдена',
    pc: 'шт',
    none: 'Нет'
  },
  types: {
    system: {
      RIG: 'tornado.kg',
      SHOP: 'store.tornado.kg'
    },
    project: {
      IMAGE: 'Изображение',
      YOUTUBE: 'Ютуб'
    },
    productStatuses: {
      IN_STOCK: 'В наличии',
      OUT_OF_STOCK: 'Нет в наличии',
      ON_ORDER: 'На заказ',
      COMING_SOON: 'Ждём поступления',
    },
    productTags: {
      SALE: 'Акция',
      NEW: 'Новинка',
      HOT: 'Хит',
      EXCLUSIVE: 'Эксклюзив',
      LIMITED: 'Ограничено',
      BEST_PRICE: 'Лучшая цена'
    },
    paymentTypes: {
      CASH: 'Наличными',
      NON_CASH: 'Безналичными'
    },
    discountTypes: {
      WHOLESALE: 'Оптом',
      SALE: 'Акция',
      COUPON: 'Купон',
      PRICE_POLICY: 'Ценовая политика'
    },
    orderStatuses: {
      PENDING: 'В ожидании',
      PREPARING: 'Готовится',
      READY: 'Готов',
      IN_DELIVERY: 'В доставке',
      DELIVERED: 'Доставлено',
      COMPLETED: 'Завершено',
      RETURNED: 'Возвращено',
      CANCELED: 'Отменено'
    },
    orderStatusPayments: {
      NO: 'Не оплачено',
      PART: 'Частично оплачено',
      YES: 'Полностью оплачено'
    },
    cashOnsInfo: {
      DELIVERY: 'Оплата',
      CHECK: 'Оплата',
      SELF_DELIVERY: 'Оплата'
    },
    clientTypes: {
      REGULAR: 'Обычный',
      WHOLESALER: 'Оптовик',
      ADMIN: 'Админ',
      LOYAL: 'Постоянник'
    },
    nodePositions: {
      LEFT: 'Слева',
      RIGHT: 'Справа',
      CENTER: 'В центре',
      LEFT_WITH_TEXT: 'Слева с текстом',
      RIGHT_WITH_TEXT: 'Справа с текстом'
    }
  },
  auth: {
    login: 'Вход',
    loggingOut: 'Выход...',
    passwordRecovery: 'Восстановление пароля',
    rememberYourPassword: 'Помните свой пароль?',
    instructionDescription: 'Инструкции по восстановлению пароля были отправлены. Пожалуйста, проверьте свою электронную почту',
    goToLoginScreen: 'Перейти на экран входа',
    passwordRecoveryConfirmation: 'Подтверждение восстановления пароля',
    invalidResetTokenDescription: 'Неверный токен. Пожалуйста, попробуйте восстановить пароль снова',
    goToPasswordRecoveryScreen: 'Перейти на экран восстановления пароля',
    changePassword: 'Изменить пароль',
    yourPasswordSuccessfullyChanged: 'Ваш пароль был успешно изменен',
  },
  pages: {
    pages: 'Страницы',
    home: 'Главная',
    aboutUs: 'О нас',
    whyWe: 'Почему мы?',
    services: 'Услуги',
    features: 'Условия',
    contacts: 'Контакты',
    socialLinks: 'Социальные сети',
    portfolio: 'Портфолио',
    skills: 'Навыки',
    testimonials: 'Отзывы',
    funFacts: 'Достижения',
    faq: 'Вопросы и ответы',
    team: 'Команда',
    userManagement: 'Управление пользователями',
    users: 'Пользователи',
    userGroups: 'Группы пользователей',
    mainDescription: 'Выберите нужную конфигурацию',
    settings: 'Настройки',
    currencies: 'Валюты',
    pricePolicy: 'Ценовая политика',
    publicOffer: 'Публичная оферта',
    privacyPolicy: 'Политика конфиденциальности'
  },
  shop: {
    orders: 'Заказы',
    products: 'Товары',
    blog: 'Блог',
    clients: 'Клиенты',
    requests: 'Запросы',
    tornado: 'Торнадо',
    shop: 'Магазин',
    settings: 'Настройки',
    productsCategories: `Категории товаров`,
    productsSubcategories: `Подкатегории товаров`,
    productsBrands: `Бренды товаров`,
    coupons: 'Купоны',
    branches: 'Филиалы',
    requestsFromTornado: 'Запросы от tornado.kg',
    requestsFromShop: 'Запросы от store.tornado.kg',
    shownInDetails: 'будет отображаться в деталях',
    productReviews: 'Отзывы товаров'
  },
  modals: {
    user: {
      add: 'Добавить нового пользователя',
      edit: 'Редактировать пользователя'
    },
    userGroup: {
      add: 'Добавить новую группу',
      edit: 'Редактировать группу'
    },
    aboutUs: {
      add: 'Добавить новую информацию о нас',
      edit: 'Редактировать информацию о нас'
    },
    whyWe: {
      add: 'Добавить новую информацию о нас',
      edit: 'Редактировать информацию о нас'
    },
    service: {
      add: 'Добавить новую услугу',
      edit: 'Редактировать услугу'
    },
    feature: {
      add: 'Добавить новое условие',
      edit: 'Редактировать условие'
    },
    product: {
      add: 'Добавить новый товар',
      edit: 'Редактировать товар',
      updateImages: 'Обновить изображения товара'
    },
    blog: {
      add: 'Добавить новый блог',
      edit: 'Редактировать блог',
      updateImages: 'Обновить главное изображение блога'
    },
    project: {
      add: 'Добавить новый проект',
      edit: 'Редактировать проект'
    },
    testimonial: {
      add: 'Добавить новый отзыв',
      edit: 'Редактировать отзыв'
    },
    skill: {
      add: 'Добавить новый навык',
      edit: 'Редактировать навык'
    },
    contact: {
      add: 'Добавить новый контакт',
      edit: 'Редактировать контакт'
    },
    socialLink: {
      add: 'Добавить новую социальную сеть',
      edit: 'Редактировать социальную сеть'
    },
    faq: {
      add: 'Добавить новый вопрос и ответ',
      edit: 'Редактировать вопрос и ответ'
    },
    funFact: {
      add: 'Добавить новое достижение',
      edit: 'Редактировать достижение'
    },
    staff: {
      add: 'Добавить нового сотрудника',
      edit: 'Редактировать сотрудника'
    },
    client: {
      add: 'Добавить нового клиента',
      edit: 'Редактировать клиента',
      ban: 'Вы уверены, что хотите заблокировать этого клиента?',
      unban: 'Вы уверены, что хотите разблокировать этого клиента?'
    },
    productBrand: {
      add: 'Добавить новый бренд товара',
      edit: 'Редактировать бренд товара'
    },
    productCategory: {
      add: 'Добавить новую категорию товара',
      edit: 'Редактировать категорию товара'
    },
    productSubcategory: {
      add: 'Добавить новую подкатегорию товара',
      edit: 'Редактировать подкатегорию товара'
    },
    branch: {
      add: 'Добавить новый филиал',
      edit: 'Редактировать филиал'
    },
    coupon: {
      add: 'Добавить новый купон',
      edit: 'Редактировать купон'
    },
    request: {
      info: 'Информация о запросе',
      fromSystem: 'Из системы',
      notAnswered: 'Еще не отвечено',
      answered: 'Уже отвечено'
    },
    currency: {
      add: 'Добавить новую валюту',
      edit: 'Редактировать валюту'
    },
    order: {
      edit: 'Редактировать заказ',
      return: 'Возврат заказа',
      cancel: 'Отменить заказ',
      returnInfo: 'Вы уверены, что хотите вернуть заказ? Пожалуйста, укажите причину:',
      cancelInfo: 'Вы уверены, что хотите отменить заказ? Пожалуйста, укажите причину:',
      complete: 'Вы хотите завершить заказ?',
      status: 'Изменить статус заказа',
      paymentAdd: 'Добавить оплату',
      paymentEdit: 'Редактировать оплату',
      itemAdd: 'Добавить товар в заказ',
      itemEdit: 'Редактировать товар заказа',
      statusInfo: 'Статус заказа',
      statusPaymentInfo: 'Оплаты заказа',
      orderItems: 'Товары заказа',
      details: 'Детали заказа',
      linkOrderToClient: 'Привязать клиента к заказу'
    },
    pricePolicy: {
      add: 'Добавить новую ценовую политику',
      edit: 'Редактировать ценовую политику'
    },
    productReview: {
      edit: 'Редактировать отзыв о товаре',
      replies: 'Ответы отзывов',
      editReply: 'Редактировать ответ отзыва о товаре'
    },
  },
  userGroups: {
    manager: 'Менеджер',
    admin: 'Администратор',
    other: 'Другое',
  },
  editor: {
    default: 'Нормальный',
    defaultShort: 'нор',
    byDefault: 'Обычный',
    bold: 'Жирный',
    italic: 'Курсив',
    strikethrough: 'Зачеркнутый',
    underline: 'Подчеркнутый',
    heading: 'Заголовок',
    normalText: 'Обычный текст',
    heading1: 'Заголовок 1',
    heading2: 'Заголовок 2',
    heading3: 'Заголовок 3',
    heading4: 'Заголовок 4',
    heading5: 'Заголовок 5',
    heading6: 'Заголовок 6',
    fontSize: 'Размер шрифта',
    increaseFontSize: 'Увеличить размер шрифта',
    decreaseFontSize: 'Уменьшить размер шрифта',
    textColor: 'Цвет текста',
    highlightColor: 'Цвет выделения',
    align: 'Выравнивание',
    leftAlign: 'Выравнивание по левому краю',
    centerAlign: 'Выравнивание по центру',
    rightAlign: 'Выравнивание по правому краю',
    justify: 'Выравнивание по ширине',
    fontStyle: 'Стиль шрифта',
    lineSpacing: 'Межстрочный интервал',
    checklist: 'Список задач',
    bulletedList: 'Маркированный список',
    numberedList: 'Нумерованный список',
    horizontalRule: 'Горизонтальная линия',
    blockquote: 'Цитата',
    code: 'Код',
    codeBlock: 'Блок кода',
    hyperlink: 'Гиперссылка',
    table: 'Таблица',
    editTable: 'Редактировать таблицу',
    insertTable: 'Вставить таблицу',
    removeTable: 'Удалить таблицу',
    toggleHeaderRow: 'Переключить строку заголовка',
    toggleHeaderColumn: 'Переключить колонку заголовка',
    toggleHeaderCell: 'Переключить ячейку заголовка',
    insertColumnLeft: 'Вставить колонку слева',
    insertColumnRight: 'Вставить колонку справа',
    removeSelectedColumns: 'Удалить выбранные колонки',
    insertRowUp: 'Вставить строку вверх',
    insertRowDown: 'Вставить строку вниз',
    removeSelectedRows: 'Удалить выбранные строки',
    mergeCells: 'Объединить ячейки',
    splitCell: 'Разделить ячейку',
    cellColor: 'Цвет ячейки',
    insertImage: 'Вставить изображение',
    insertVideo: 'Вставить видео',
    insertYoutubeVideo: 'Вставить Youtube видео',
    addEmoji: 'Добавить эмодзи',
    undo: 'Отменить',
    redo: 'Повторить'
  },
  fileBrowser: {
    deletion: 'Удаление',
    selectFolderOrFile: 'Выберите папку или файл',
    noFilesOrFoldersFound: 'Файлы или папки не найдены',
    folderIsEmpty: 'Папка пуста',
    deleteDescription: 'Вы уверены, что хотите удалить <b>{type}</b>?<br><em>{baseName}</em>',
    thisFolder: 'эту папку',
    thisFile: 'этот файл',
    upTo: 'До: {value}',
    uploadTo: 'Загрузить в:',
    maxFilesCount: 'Максимальное количество файлов: {value}',
    maxFileSize: 'Максимальный размер файла: {value}',
  },
  formLabels: {
    file: 'Файл',
    size: 'Размер',
    filter: 'Фильтр',
    from: 'От',
    to: 'До',
    sum: 'Сумма',
    currency: 'Валюта',
    paymentType: 'Тип оплаты',
    discountType: 'Тип скидки',
    notes: 'Примечание',
    enterComment: 'Введите комментарий',
    date: 'Дата',
    searchByTitle: 'Поиск по названию',
    refund: 'Возврат',
    cashBox: 'Кассовый аппарат',
    title: 'Название',
    firstName: 'Имя',
    lastName: 'Фамилия',
    telNumber: 'Телефонный номер',
    email: 'Электронная почта',
    userGroup: 'Группа пользователей',
    privileges: 'Привилегии',
    yourEmail: 'Ваша электронная почта',
    password: 'Пароль',
    enterYourEmail: 'Введите вашу электронную почту',
    enterNewPassword: 'Введите новый пароль',
    confirmYourNewPassword: 'Подтвердите новый пароль',
    subtitle: 'Подзаголовок',
    location: 'Местоположение',
    coverImage: 'Изображение обложки',
    backgroundImage: 'Фоновое изображение',
    shopBackgroundImage: 'Фоновое изображение магазина',
    primaryLogo: 'Основной логотип',
    secondaryLogo: 'Вторичный логотип',
    primaryShopLogo: 'Основной логотип магазина',
    secondaryShopLogo: 'Вторичный логотип магазина',
    description: 'Описание',
    quote: 'Цитата',
    experienceYear: 'Опыт с (пр. 2010)',
    showInHome: 'Использовать на странице "Главная"',
    isAboutPage: 'Использовать на странице "О нас"',
    isWhyWe: `Использовать на секции "Почему мы"`,
    image: 'Изображение',
    tags: 'Краткие комментарии',
    blogTags: 'Тэги (можно делить запятыми)',
    keywordsBlogHint: 'Укажите 3–5 уникальных и подходящих слова для этого блога, которые отражают его тему. Разделяйте запятыми без пробела.',
    keywordsProductHint: 'Укажите 3-5 уникальных и подходящих слова для этого товара, которые отражают его. Разделяйте запятыми без пробела.',
    isService: 'Использовать на странице "Услуги"',
    videoImage: 'Изображение видео',
    urlVideo: 'ID из ссылки на видео (YouTube)',
    symbolLeft: 'Символ слева от цены',
    example: 'Пример',
    exampleVideoUrl: 'Выделите 11-значный код из ссылки как выделено внизу красными буквами и вставьте в поле',
    profession: 'Профессия',
    percent: 'Процент',
    telegram: 'Ссылка на Telegram',
    whatsapp: 'Ссылка на WhatsApp',
    showInSites: 'Показывать на сайтах',
    showInAbouts: 'Показывать на стр. "О нас"',
    iconSearchHint: 'Иконку можно найти:',
    here: 'здесь',
    mainContact: 'Основной контакт',
    leftImage: 'Левое изображение',
    rightImage: 'Правое изображение',
    value: 'Значение',
    url: 'Ссылка',
    icon: 'Иконка',
    category: 'Категория',
    subcategory: 'Подкатегория',
    productCategoryInfo: 'Выбирайте, или категорию, или подкатегорию',
    projectType: 'Тип портфолио',
    name: 'Имя',
    comment: 'Комментарий',
    position: 'Должность',
    question: 'Вопрос',
    answer: 'Ответ',
    fullName: 'Полное имя',
    fullNameEmailTelNumberSearch: 'Поиск по имени, почте или телефону',
    admin: 'Администратор',
    address: 'Адрес',
    clientId: 'ID клиента',
    deliveryPrice: 'Цена доставки',
    code: 'Код',
    validTo: 'Действителен до',
    validFrom: 'Действителен от',
    discountPercent: 'Скидка в процентах',
    message: 'Сообщение',
    language: 'Язык',
    descriptionShort: 'Краткое описание',
    brand: 'Бренд',
    onlineShopSection: 'Раздел интернет-магазина',
    otherImages: 'Другие изображения',
    addImage: 'Добавить новое изображение',
    productExample: 'Пример товара на разных языках и валютах',
    price: 'Цена',
    overprice: 'Наценка',
    showInShop: 'Показывать в интернет-магазине',
    homeBanner: 'Показывать в баннере магазина',
    inStock: 'В наличии',
    quantity: 'Количество',
    mainCurrency: 'Основная валюта',
    symbol: 'Символ',
    status: 'Статус',
    tag: 'Тег',
    link: 'Ссылка',
    delivery: 'Доставка',
    orderNumber: 'Номер заказа',
    cashOn: 'Оплата при',
    statusPayment: 'Статус оплаты',
    registeredAt: 'Зарегистрирован',
    client: 'Клиент',
    branch: 'Филиал',
    order: 'Заказ',
    usedCoupon: 'Использованный купон',
    deliveryTo: 'Доставка на',
    selfDeliveryFrom: 'Самовывоз из',
    total: 'Итого',
    paymentIs: 'Оплата',
    paymentLeft: 'Осталось оплатить',
    paid: 'Оплачено',
    orderIs: 'Статус заказа',
    totalCount: 'Всего позиций',
    totalQuantity: 'Всего товаров',
    reason: 'Причина',
    orderNumOrClient: 'Номер заказа или имя, телефон, email клиента',
    titleOrClient: 'Название или имя клиента',
    content: 'Контент',
    public: 'Публичный пост',
    author: 'Автор',
    enterUrl: 'Введите ссылку',
    enterEmbedUrl: 'Введите youtube видео код (11 букв)',
    showInClientAddress: 'Показывать в секции адреса клиента',
    wholesalePrice: 'Оптовая цена',
    fromPrice: 'Цена от',
    forClients: 'Для клиентов',
    type: 'Тип клиента',
    productDiscountHint: 'Скидка работает только при теге "Акция"',
    productWholesalePriceHint: 'Если пустая, оптовикам покажет обычную цену',
    product: 'Товар',
    createdAt: 'Создан',
    rating: 'Оценка',
    productTitle: 'Название товара',
    thesis: 'Тезис',
    widthInPercent: 'Ширина в %',
    nodePosition: 'Позиция',
    youtubeDescription: 'Это всего лишь контейнер для видео с YouTube, и столько место он занимает. Вы не видите само видео, но он здесь. Если указали правильный ID, всё заработает. Нажмите на ссылку, если заработает значит правильно.',
    autoUse: 'Применять автоматически на заказы',
    firstOrder: 'Для первых заказов',
    toBanner: 'Показывать в баннере',
    wideImage: 'Широкая картина',
    mobileImage: 'Вертикальная картина',
    wholesale: 'оптом',
    clientNotes: 'Примечание клиента',
    amount: 'Сумма',
    couponBannerWideImageHint: `<b>Идеальный баннер - </b>16:9<br/>
Ограниченные поля - находятся в зоне риска невидимости на разных экранах. Старайтесь на этих полях оставлять "пустоту".`,
    couponBannerMobileImageHint: `<b>Идеальный баннер для вертикальных экран (2 картина)</b>:<br/>
Для вертикальных экран (мобильные телефоны): ширина / длина = 0.525 (например: ширина = 420px, длина = 800px, итого соотношение 0.525)<br/>
<b>Если простыми словами 9:16 пойдет</b>`,
    warningOrderItems: 'Внимание! Опасная зона! Если вы хотите изменить цены товаров, повлиять на стоимость заказа (например, удалить или добавить товары), убедитесь, что это согласовано с клиентом.',
    clientNotRegistered: 'Не зарегистрированный клиент',
    titleOrId: 'Название или артикул (ID)'
  },
  table: {
    id: 'ID',
    fullName: 'ФИО',
    email: 'Почта',
    telNumber: 'Тел. номер',
    userGroup: 'Группа',
    active: 'Активные',
    privileges: 'Привилегии',
    title: 'Название',
    actions: 'Действия',
    type: 'Тип',
    price: 'Стоимость',
    category: 'Категория',
    amount: 'Сумма',
    paymentType: 'Тип оплаты',
    currency: 'Валюта',
    num: '№',
    supervisor: 'Супервайзор',
    executor: 'Исполнитель',
    where: 'Где',
    description: 'Описание',
    createdAt: 'Создано',
    deadline: 'Срок',
    status: 'Статус',
    priority: 'Приоритет',
    number: 'Номер',
    numberType: 'Тип номера',
    cleaning: 'Уборка',
    checkIn: 'Заезд',
    checkOut: 'Выезд',
    guestFullName: 'ФИО гостя',
    cleanerFullName: 'ФИО клинера',
    adults: 'Взрослые',
    subtitle: 'Подзаголовок',
    children: 'Дети',
    bookingStatus: 'Статус брони',
    numberStatus: 'Статус номера',
    notes: 'Примечание',
    expFrom: 'Опыт с',
    isAboutPage: 'Страница "О нас"',
    showInHome: 'Страница "Главная"',
    isService: 'Страница "Услуги"',
    percent: 'Процент',
    telegram: 'Telegram',
    whatsapp: 'WhatsApp',
    showIn: 'Показывать в',
    isMain: 'Является основным',
    value: 'Значение',
    name: 'Имя',
    position: 'Должность',
    question: 'Вопрос',
    admin: 'Администратор',
    banned: 'Заблокирован',
    address: 'Адрес',
    discount: 'Скидка',
    validTo: 'Действителен',
    fromSite: 'С сайта',
    mainCurrency: 'Основная валюта',
    symbol: 'Символ',
    usingInSystem: 'Используется в системе',
    code: 'Код',
    showInShop: 'Показывается в интернет-магазине',
    tag: 'Тег',
    profession: 'Профессия',
    client: 'Клиент',
    cashOn: 'Оплата при',
    payment: 'Оплата осталось',
    delivery: 'Доставка',
    registeredAt: 'Зарегистрирован',
    orderNum: 'Номер заказа',
    yes: 'Есть',
    no: 'Нет',
    rating: 'Рейтинг',
    product: 'Товар',
    timeToRead: 'Время для чтения',
    words: 'Кол-во слов',
    minRead: 'мин чтения',
    public: 'Публичный',
    wholesale: 'оптом',
    fromPrice: 'Цена от',
    forClients: 'Для клиентов',
    quantity: 'Количество',
    repliesCount: 'Ответы',
    comment: 'Комментарий',
    tags: 'Тэги',
    from: 'от',
    to: 'до',
    discountType: 'Тип скидки',
    pricePriceDiscount: 'Цена (цена без скидки)',
    paid: 'Оплачено'
  },
  buttons: {
    selectAll: 'Выбрать всё',
    reload: 'Перезагрузить',
    logout: 'Выйти',
    disclose: 'Раскрыть',
    close: 'Закрыть',
    reset: 'Сбросить',
    form: 'Сформировать',
    remove: 'Удалить',
    delete: 'Удалить',
    recover: 'Восстановить',
    save: 'Сохранить',
    cancel: 'Отмена',
    add: 'Добавить',
    back: 'Назад',
    edit: 'Редактировать',
    view: 'Посмотреть',
    movement: 'Переезд',
    checkIn: 'Заезд',
    checkOut: 'Выезд',
    payment: 'Оплата',
    invoiceForPayment: 'Счёт к оплате',
    invoice: 'Счёт фактура',
    confirmationInvoice: 'Подтверждение брони',
    addPayment: 'Добавить оплату',
    closeShift: 'Закрыть смену',
    sendToCashBox: 'Перевод в кассу',
    transferShift: 'Приём-передача',
    collectionShift: 'Инкассация',
    submit: 'Подтвердить',
    getShift: 'Принять смену',
    send: 'Отправить',
    openShift: 'Открыть смену',
    collect: 'Изъять',
    actions: 'Действия',
    forgotYourPassword: 'Забыли пароль?',
    login: 'Войти',
    ban: 'Заблокировать',
    unban: 'Разблокировать',
    yes: 'Да',
    clear: 'Очистить',
    makeAnswered: 'Отметить как отвеченное',
    answerLater: 'Ответить позже',
    confirm: 'Подтвердить',
    details: 'Детали',
    use: 'Использовать',
    unuse: 'Не использовать',
    menu: 'Меню',
    changeStatus: 'Изменить статус',
    showPayments: 'Список оплат',
    showItems: 'Список товаров',
    complete: 'Завершить',
    return: 'Вернуть',
    images: 'Изображения',
    enterImageUrl: 'Введите ссылку изображения',
    enterVideoUrl: 'Введите ссылку видео',
    select: 'Выбрать',
    createFolder: 'Создать папку',
    uploadFiles: 'Загрузить файлы',
    addFiles: 'Добавить файлы',
    upload: 'Загрузить',
    link: 'Привязать',
    unlink: 'Отвязать',
    showReplies: 'Список ответов',
    linkToClient: 'Привязать к клиенту'
  },
  $vuetify: {
    badge: 'знак',
    close: 'Закрыть',
    dataIterator: {
      noResultsText: 'Не найдено подходящих записей',
      loadingText: 'Запись загружается...',
    },
    dataTable: {
      itemsPerPageText: 'Строк на странице:',
      ariaLabel: {
        sortDescending: 'Упорядочено по убыванию.',
        sortAscending: 'Упорядочено по возрастанию.',
        sortNone: 'Не упорядочено.',
        activateNone: 'Активируйте, чтобы убрать сортировку.',
        activateDescending: 'Активируйте для упорядочивания убыванию.',
        activateAscending: 'Активируйте для упорядочивания по возрастанию.',
      },
      sortBy: 'Сортировать по',
    },
    dataFooter: {
      itemsPerPageText: 'Записей на странице:',
      itemsPerPageAll: 'Все',
      nextPage: 'Следующая страница',
      prevPage: 'Предыдущая страница',
      firstPage: 'Первая страница',
      lastPage: 'Последняя страница',
      pageText: '{0}-{1} из {2}',
    },
    datePicker: {
      itemsSelected: '{0} выбран',
      nextMonthAriaLabel: 'Следующий месяц',
      nextYearAriaLabel: 'Следующий год',
      prevMonthAriaLabel: 'Прошлый месяц',
      prevYearAriaLabel: 'Предыдущий год',
    },
    noDataText: 'Отсутствуют данные',
    carousel: {
      prev: 'Предыдущий слайд',
      next: 'Следующий слайд',
      ariaLabel: {
        delimiter: 'Слайд {0} из {1}',
      },
    },
    calendar: {
      moreEvents: 'Еще {0}',
    },
    input: {
      clear: 'Очистить {0}',
      prependAction: '{0} добавленное действие',
      appendAction: '{0} добавленное действие',
    },
    fileInput: {
      counter: 'Файлов: {0}',
      counterSize: 'Файлов: {0} (всего {1})',
    },
    timePicker: {
      am: 'AM',
      pm: 'PM',
    },
    pagination: {
      ariaLabel: {
        wrapper: 'Навигация по страницам',
        next: 'Следующая страница',
        previous: 'Предыдущая страница',
        page: 'Перейти на страницу {0}',
        currentPage: 'Текущая страница, Страница {0}',
      },
    },
    rating: {
      ariaLabel: {
        icon: 'Рейтинг {0} из {1}',
      },
    },
    loading: 'Загрузка...',
  },
};
